<template>
  <div class="contaier">
    <div class="top-nvb_box">
      <span class="lang" @click="changeLanguage($i18n.locale)">{{
        $t("home.lang")
      }}</span>
    </div>
    <div class="top-banner">
      <img
        alt=""
        src="./assets/img/banner2.jpg"
        class="img lg:aspect-7/3 md:aspect-5/3 aspect-4/5"
      />
    </div>
    <form-page ref="formPageRef"></form-page>
    <!-- <footer-page></footer-page> -->
  </div>
</template>

<script>
// import { carouselList, textList, imgsrc } from '@/assets/js/static.js'
import FormPage from "@/components/FormPage.vue";
// import FooterPage from "@/components/FooterPage.vue";
export default {
  name: "HomeView",
  components: {
    FormPage,
    // FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      speak: "中文",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    changeLanguage(lang) {
      console.log("lang :>> ", lang);
      this.$i18n.locale = lang === "zh" ? "en" : "zh";
      this.$refs.formPageRef.changeLanguage(lang);
      // this.currentLanguage = lang === 'en'? 'English' : '中文';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";
.img {
  object-fit: cover;
}
.contaier {
  .top-nvb_box {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 20px;
    text-align: right;
    .lang {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
// .top-banner {
// }
</style>
